export const LOADING_APP = 'LOADING_APP'
export const TAB = 'TAB'

const initialState = {
  app_loading: true,
  tab: 'settings',
}

export default function (
  state = {
    ...initialState,
  },
  action = {}
) {
  switch (action.type) {
    case LOADING_APP:
      return {
        ...state,
        app_loading: action.data,
      }
    case TAB:
      return {
        ...state,
        tab: action.tab
      }
    default:
      return state
  }
}
